export const COLOR_PRIMARY = "#FF7D00"


// COLOR HEX CODES
export const COLOR_RED = "#E53935"
export const COLOR_RED_AGING = "#B71C1C"

export const COLOR_TEAL = "#26A69A"
export const COLOR_TEAL_AGING = "#00695C"

export const COLOR_DEEP_PURPLE = "#673AB7"
export const COLOR_DEEP_PURPLE_AGING = "#311B92"

export const COLOR_INDIGO = "#3F51B5"
export const COLOR_INDIGO_AGING = "#1A237E"

export const COLOR_ORANGE = "#FF9800"
export const COLOR_ORANGE_AGING = "#E65100"

export const COLOR_BLUE = "#1E88E5"
export const COLOR_BLUE_AGING = "#0D47A1"

export const COLOR_PURPLE = "#9C27B0"
export const COLOR_PURPLE_AGING = "#4A148C"


export const COLOR_GREEN = "#4CAF50"
export const COLOR_GREEN_AGING = "#2E7D32"

export const COLOR_PINK = "#FF4081"
export const COLOR_PINK_AGING = "#880E4F"

export const COLOR_GRAY = "#757575"
export const COLOR_GRAY_AGING = "#212121"

export const COLOR_LIGHT_BLUE = "#B3E5FC"
export const COLOR_LIGHT_BLUE_AGING = "#29B6F6"

export const COLOR_BROWN = "#795548"
export const COLOR_BROWN_AGING = "#3E2723"

export const COLOR_LIGHT_GREEN = "#8BC34A"
export const COLOR_LIGHT_GREEN_AGING = "#558B2F"


export const COLOR_DEEP_ORANGE = "#FF8A65"
export const COLOR_DEEP_ORANGE_AGING = "#F4511E"

export const COLOR_BLUE_GRAY = "#607D8B"
export const COLOR_BLUE_GRAY_AGING = "#263238"

export const COLOR_LIME = "#EEFF41"
export const COLOR_LIME_AGING = "#AEEA00"

export const COLOR_LIGHT_GRAY = "#FAFAFA"
export const COLOR_LIGHT_GRAY_AGING = "#BDBDBD"

// EXTRA COLORS FOR ADDITIONAL MARKER TYPES
export const COLOR_AMBER = "#FFC107"
export const COLOR_AMBER_AGING = "#FF6F00"

export const COLOR_CYAN = "#00BCD4"
export const COLOR_CYAN_AGING = "#006064"

export const COLOR_DEEP_GREEN = "#1B5E20"
export const COLOR_DEEP_GREEN_AGING = "#004D40"

export const COLOR_MAGENTA = "#E040FB"
export const COLOR_MAGENTA_AGING = "#6A1B9A"

export const COLOR_DARK_ORANGE = "#FF5722"
export const COLOR_DARK_ORANGE_AGING = "#BF360C"

export const COLOR_STEEL_BLUE = "#3F729B"
export const COLOR_STEEL_BLUE_AGING = "#1C3B57"

export const COLOR_VIOLET = "#7C4DFF"
export const COLOR_VIOLET_AGING = "#311B92"

export const COLOR_ROSE = "#F48FB1"
export const COLOR_ROSE_AGING = "#EC407A"

export const COLOR_MINT = "#69F0AE"
export const COLOR_MINT_AGING = "#00E676"

export const COLOR_LAVENDER = "#B388FF"
export const COLOR_LAVENDER_AGING = "#7C4DFF"

export const COLOR_YELLOW = "#FFEB3B"
